import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import type { BaseLineItem } from '@/views/dashboard/safe-status/base-line/base-line.service'

export interface BaselineCategoryTopItem {
  /** 检测项 id，柱状图点击终端列表用 */
  check_item_id?: string
  category_name: string
  /** 影响终端数 */
  terminal_count: number
}

export interface BaselineTerminalTopItem {
  computer_name: string
  group_name?: string
  substandard_count: number
  /** 来自终端列表行，供 TOP 排行点击打开详情 */
  device?: BaseLineItem
}

export interface StatsData {
   /** 不合规终端数量 */
  substandard_num: number

  /** 近7天未扫描数量 */
  last_uncheck_num: number

  /** 不合规项总数（去重统计） */
  non_compliance_total: number

  /** 合规率（百分比数值，如 85 表示 85%） */
  compliance_rate?: number
}
@Injectable()
export class BaseLineHeaderService {
  constructor (private http: Http) {}

  getBaseLineCheckResultStats () {
    return this.http.post<StatsData>('/baselinecheck/result/stats', {})
  }

  getRepairResult (data: { task_id: string }) {
    return this.http.post<{is_finish: boolean, repair_total: number}>('/baseline-check/repair-result/get', data)
  }
}
